import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import { BoysenberryAppContext } from '@dev-agents/boysenberry-utils';
import { useTenantData } from '@dev-agents/tenant-context';
import { useCallback, useEffect, useMemo } from 'react';
import { useQueryLoader } from 'react-relay';
import { useRouter } from 'react-resource-router';

import type { flowScreen_loadFlowQuery } from './components/__generated__/flowScreen_loadFlowQuery.graphql';
import query from './components/__generated__/flowScreen_loadFlowQuery.graphql';
import { FlowScreen } from './components/flow-screen';

export const path = '/boysenberry/flow/:flowId';

export const BoysenberryFlow = () => {
	const { tenantContexts } = useTenantData();
	const { cloudId } = tenantContexts[0];

	const [queryRef, loadQuery] = useQueryLoader<flowScreen_loadFlowQuery>(query);
	const [routeState] = useRouter();

	const flowId = useMemo(() => {
		if (routeState.match.params.flowId) {
			return routeState.match.params.flowId;
		}
		return null;
	}, [routeState.match.params.flowId]);

	useEffect(() => {
		if (flowId) {
			loadQuery({ sessionId: flowId, cloudId });
		}
	}, [cloudId, loadQuery, flowId]);

	const refreshQuery = useCallback(() => {
		if (flowId) {
			loadQuery({ sessionId: flowId, cloudId }, { fetchPolicy: 'store-and-network' });
		}
	}, [cloudId, flowId, loadQuery]);

	return (
		<BoysenberryAppContext isFullscreen>
			<Placeholder name="boysenberry-flow-screen">
				{queryRef ? (
					<FlowScreen
						key={flowId}
						flowId={flowId}
						queryRef={queryRef}
						refreshQuery={refreshQuery}
					/>
				) : (
					<UFOLoadHold name="boysenberry-flow-screen" />
				)}
			</Placeholder>
		</BoysenberryAppContext>
	);
};
